<template>
  <div>
    <BaseCheckbox
      :id="$id('allow-repayments')"
      name="repayment"
      @input="handleRepaymentChange"
      v-model="repayment"
    >
      {{
        isChangeNameRepaymentToPayment
          ? $t("items.prices.payment_start")
          : $t("items.prices.repayment_start")
      }}
      <span v-if="repaymentCountOptions.length > 1">
        <select
          v-model="repaymentCount"
          @change="handleInstallmentChange"
          :disabled="repaymentCountOptions.length === 1"
          class="f-form-select f-w-16 f-pl-3 f-py-1 f-text-base focus:f-outline-none f-border-gray-300 f-rounded-md f-text-gray-700"
        >
          <option
            v-for="option in repaymentCountOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </span>
      <span v-else>{{ repaymentCount }}</span>

      {{
        isChangeNameRepaymentToPayment
          ? $tc("items.prices.payment_end", repaymentCount)
          : $tc("items.prices.repayment_end", repaymentCount)
      }}
    </BaseCheckbox>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseCheckbox from "@/components/Form/Basic/Inputs/BaseCheckbox.vue";
import UrlParser from "@/module/Utils/UrlParser";

export default Vue.extend({
  name: "Repayment",
  components: { BaseCheckbox },
  props: {
    initialRepayment: {
      type: Boolean,
      default: false,
    },
    repaymentCountOptions: {
      type: Array as () => number[],
      default: () => [2],
    },
    isChangeNameRepaymentToPayment: {
      type: Boolean,
    },
  },
  data() {
    return {
      repayment: this.initialRepayment,
      repaymentCount: this.repaymentCountOptions[0],
    };
  },

  mounted() {
    const value = UrlParser.getInstance().getParam("fapi-form-repayment");

    if (value !== null && value !== "") {
      this.repayment = value === "1";
    }

    if (this.repayment) {
      this.$nextTick(() => {
        this.$emit("repaymentChanged", this.repayment);
        this.$emit("installmentsChanged", this.repaymentCount);
      });
    }
  },
  watch: {
    repayment(newValue: boolean) {
      if (newValue) {
        this.$emit("repaymentChanged", newValue);
        this.$emit("installmentsChanged", this.repaymentCount);
      } else {
        this.$emit("repaymentChanged", newValue);
        this.$emit("installmentsChanged", 0);
      }
    },
  },
  methods: {
    handleRepaymentChange() {
      if (this.repayment) {
        this.$emit("repaymentChanged", this.repayment);
        this.$emit("installmentsChanged", this.repaymentCount);
      } else {
        this.$emit("repaymentChanged", this.repayment);
        this.$emit("installmentsChanged", 0);
      }
    },
    handleInstallmentChange() {
      this.repayment = true;
      this.$emit("installmentsChanged", this.repaymentCount);
    },
  },
});
</script>

<style lang="scss"></style>
